import cookie from "js-cookie";

export function getCookie(name) {
  console.log("i am called for cookie")

  let value = cookie.get("XSRF-TOKEN");
  // console.log("all cookies",document.cookie)
  console.log("value of XSRF-TOKEN ",value)
  
  return value;

}